import { render, staticRenderFns } from "./TripPlanningDefaults.vue?vue&type=template&id=63d57152&scoped=true"
import script from "./TripPlanningDefaults.vue?vue&type=script&lang=ts"
export * from "./TripPlanningDefaults.vue?vue&type=script&lang=ts"
import style0 from "./TripPlanningDefaults.vue?vue&type=style&index=0&id=63d57152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d57152",
  null
  
)

export default component.exports